import { InvoiceChargeType } from "../../types"
import { Badge, Box, Card, CardBody, Grid, Text, VStack, Tooltip } from "@chakra-ui/react";

type InvoiceChargesSectionProps = {
    invoice_charges: InvoiceChargeType[]
}

function InvoiceChargesSection({invoice_charges}: InvoiceChargesSectionProps) {

    if (!invoice_charges) return <div>Loading...</div>;
    return (
        <Box w="100%">
            <Card>
                <CardBody>
                    <VStack spacing={3} align="stretch">
                        {invoice_charges.map((charge, idx) => (
                            <Box key={idx}  borderBottom="1px solid" borderColor="gray.100">
                                <Grid templateColumns="180px 1fr 90px 20px 80px 110px 80px" alignItems="center" columnGap={2}>
                                    <Text fontWeight={'semibold'} fontSize="sm">{charge.charge_name.split('_').join(' ').toUpperCase()}</Text>
                                    <Text fontSize="sm">{charge.charge_description}</Text>
                                    <Text fontSize="sm" align="right">{charge.measure_quantity} {charge.measure_units}</Text>
                                    <Text fontSize="sm" align="center"> x </Text>
                                    <Text fontSize="sm">{charge.price}p</Text>
                                    <Text fontWeight={'semibold'} fontSize="sm" align="right">£{charge.charge_subtotal.toFixed(2)}</Text>
                                    <Tooltip label={charge.message} placement="top" hasArrow>
                                        {charge.validation === "V" ? (
                                            <Badge colorScheme="green" variant="subtle" cursor="pointer">✓ Valid</Badge>
                                        ) : charge.validation === "F" ? (
                                            <Badge colorScheme="red" variant="subtle" cursor="pointer">✗ Fail</Badge>
                                        ) : charge.validation === "M" ? (
                                            <Badge colorScheme="gray" variant="subtle" cursor="pointer">✗ Missing</Badge>
                                        ) : charge.validation === "P" ? (
                                            <Badge colorScheme="yellow" variant="subtle" cursor="pointer">Pending</Badge>
                                        ) :
                                        <Box minW="80px" />}
                                    </Tooltip>

                                </Grid>
                            </Box>
                        ))}
                    </VStack>
                </CardBody>
            </Card>
        </Box>
    )
}

export default InvoiceChargesSection